/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Options_Sponsorship1Inputs */

const ja_contact_formtype_options_sponsorship1 = /** @type {(inputs: Contact_Formtype_Options_Sponsorship1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポンサーシップ（ご協賛）に関して`)
};

const en_contact_formtype_options_sponsorship1 = /** @type {(inputs: Contact_Formtype_Options_Sponsorship1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsorship`)
};

/**
* | output |
* | --- |
* | "Sponsorship" |
*
* @param {Contact_Formtype_Options_Sponsorship1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_options_sponsorship1 = /** @type {((inputs?: Contact_Formtype_Options_Sponsorship1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Options_Sponsorship1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_options_sponsorship1(inputs)
	return en_contact_formtype_options_sponsorship1(inputs)
});
export { contact_formtype_options_sponsorship1 as "contact_formType_options_sponsorship" }